
<template>
<div class="order-manage-create-page">
<!-- <BlockPanel class="adress-info-component" v-bind="$props"> -->
    <div class="address-choose">
        <a-button type="link" @click="handleSelect">
        <img class="addressIcon" src="@/assets/img/address.png">从地址库选择
        </a-button>
    </div>
    <a-row >
         <a-col :md="8" :sm="24">
            <a-form-model-item
                label="站点名称"
                :colon="false"
            >
                <a-input v-model="startStation.stationName" placeholder="请输入"></a-input>
            </a-form-model-item>
        </a-col>
        <a-col :md="8">
            <FormItemName
                v-model.trim="startStation.contactName"
                :prop-prefix="propPrefix"
             />
        </a-col>
        <a-col :md="8" :sm="24">
            <FormItemPhone
                v-model="startStation.contactPhone"
                :prop-prefix="propPrefix"
             />
        </a-col>
        <a-col :md="8" :sm="24">
            <a-form-model-item
                label="要求取货时间"
                :colon="false"
                prop="startStation.expectTime"
                :label-col="{span: 6}"
                :wrapper-col="{span: 18}"
            >
                <a-date-picker
                    v-model="startStation.expectTime"
                    :disabled-date="disabledDate"
                    :disabled-time="disabledDateTime"
                    :show-time="{ defaultValue: defaultTime }"
                    placeholder="请选择取货时间" 
                    @change="handleChange"
                    @focus="handleFocus"/>
            </a-form-model-item>
        </a-col>
        <a-col :md="16" :sm="24">
            <!-- <FormItemAddress
            :address="startStation"
            :prop-prefix="propPrefix"
            @change="handleAdressChange" /> -->
            <a-form-model-item
                label="联系人地址"
                :colon="false"
                :label-col="{span: 3}"
                :wrapper-col="{span: 21}"
                :rules="addressRules"
                :prop="`${propPrefix}.address`"
            >
                <address-detil 
                :default-address="defaultAddress"
                :default-suffix="defaultSuffix"
                placeholder="请输入起始地详细地址"
                @updateData="handleAdressChange"
                @removeData="removeData"></address-detil>
            </a-form-model-item>
        </a-col>
    </a-row>
    <slot></slot>
<!-- </BlockPanel> -->
<SelectAddressDialog
    ref="SelectAddressDialog"
    :station-type="StationTypes.SHIPPING"
    @onSelectAddress="handleAdressFromSelectorChange"
/>
</div>

</template>
<script>
import moment from 'moment';
// import BlockPanel from '@/components/panel/BlockPanel.vue'
import FormValidator from '@/constants/formValidator'
import { mapState } from 'vuex'
import {TIME_UNIT,TIME_UNIT_MAP,range} from '@/constants/ruleConfig'
import SelectAddressDialog from '../../../orderManage/components/SelectAddressDialog.vue'
import {
    FormItemName,
    FormItemPhone,
    // FormItemAddress
} from '../../../orderManage/components/FormItem'
import { StationTypes } from '../../warehouseList/constant';
import AddressDetil from './AddressDetil.vue'
import { WAREHOUSETYPE, INTYPECODE } from '../constant';

const cn = require('ant-design-vue/es/locale-provider/zh_CN')

export default {
    components: {
        // BlockPanel,
        SelectAddressDialog,
        FormItemName,
        FormItemPhone,
        // FormItemAddress
        AddressDetil,
    },
    model: {
        prop: 'startStation',
        event: 'change'
    },
    props: {
        startStation: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        scene: {
            type: String,
            default: ''
        },
        deliverWarehouseCode: {
            type: String,
            default: ''
        },
        customerCode: {
            type: String,
            default: ''
        },
    },
    data () {
        return {
            cn,
            defaultTime: moment('00:00:00', 'HH:mm:ss'),
            propPrefix: 'startStation',
            FormValidator,
            StationTypes,
            defaultAddress: '',
            defaultSuffix: '',
            addressRules: [
                { required: true, message: '请选择地址', trigger: 'change' },
            ],
            WAREHOUSETYPE,
            INTYPECODE,
            current:null,
        }
    },
    computed:{
      ...mapState('orderRules', ['orderRules']),
    },
    watch:{
        startStation: {
            handler(val) {
                if(val.expectTimeLeft && val.expectTimeLeft.length>0){
                    this.defaultTime=moment(val.expectTimeLeft[0]||'00:00:00','HH:mm:ss')
                }else{
                    this.defaultTime=moment('00:00:00', 'HH:mm:ss')
                }
                if(val.address){
                    this.defaultSuffix = `${val.provinceName}${val.cityName}${val.countyName}${val.address}` 
                    if(!val.name){
                        this.defaultAddress = val.address.replace(`${val.provinceName}${val.cityName}${val.countyName}`, '')
                    } else {
                        this.defaultAddress = val.name
                    }
                } else {
                    this.defaultSuffix = ''
                    this.defaultAddress = ''
                }
            },
            immediate: true
        }
    },
    methods: {
      handleFocus(){
        this.current = new Date();
      },
      handleChange(value){
          if(!value){
            this.$set(this.startStation,'expectTime',null)
            return
          }
          const {flag,makeupStartTimeNum,makeupStartTimeUnit} = this.orderRules.ORDER_CREATE_TIME_CHECK;
          // 开始时间
          const startTime = flag ? moment(this.current).subtract(Number(makeupStartTimeNum),TIME_UNIT_MAP[makeupStartTimeUnit]):moment(this.current);
          // 是否跟结束日期相同
          const isSameStart = moment(this.startStation.expectTime||this.current).isSame(startTime, 'day');
          if(isSameStart){
            if(value < startTime){
              this.$set(this.startStation,'expectTime',moment(startTime))
            }else{
              this.$set(this.startStation,'expectTime',value)
            }
          }else{
            this.$set(this.startStation,'expectTime',value)
          }
      },
        disabledDate(current){
          const {flag,createStartTimeNum,makeupStartTimeNum,createStartTimeUnit,makeupStartTimeUnit} = this.orderRules.ORDER_CREATE_TIME_CHECK;
          let startTime = flag ? moment(this.current).subtract(Number(makeupStartTimeNum),TIME_UNIT_MAP[makeupStartTimeUnit]):moment(this.current).subtract(1, "days");
          let endTime =moment(this.current).add(+Number(createStartTimeNum),TIME_UNIT_MAP[createStartTimeUnit])
          if(makeupStartTimeUnit){
            startTime = moment(startTime).subtract(1 , 'days')
          }
          if(createStartTimeUnit === TIME_UNIT.HOURS){
            endTime = moment(endTime)
          }
          return current && moment(current).startOf('days') < startTime|| moment(current).startOf('days') > endTime
        },
        disabledDateTime(){
          return {
			      disabledHours: () => this.disabledHours(this.orderRules.ORDER_CREATE_TIME_CHECK),
			      disabledMinutes: () => this.disabledMinutes(this.orderRules.ORDER_CREATE_TIME_CHECK),
		      };
        },
        disabledHours(data){
          const {flag,createStartTimeNum,makeupStartTimeNum,createStartTimeUnit,makeupStartTimeUnit} = data;
          // 开始时间
          const startTime = flag ? moment(this.current).subtract(Number(makeupStartTimeNum),TIME_UNIT_MAP[makeupStartTimeUnit]):moment(this.current);
          // 结束时间
          const endTime =  moment().add(+Number(createStartTimeNum),TIME_UNIT_MAP[createStartTimeUnit])
          // 是否跟结束日期相同
          const isSameEnd = moment(this.startStation.expectTime||this.current).isSame(endTime, 'day');
          // 是否跟开始时间相同
          const isSameStart = moment(this.startStation.expectTime||this.current).isSame(startTime, 'day');
          // 获取当前时间小时
          const currentHours = moment(this.current).hour();
          // 结束时间小时数计算
          const endHours = createStartTimeUnit === TIME_UNIT.HOURS? currentHours + createStartTimeNum:currentHours;
          // 开始时间小时数计算
          const startHours = makeupStartTimeUnit === TIME_UNIT.HOURS? currentHours - makeupStartTimeNum:currentHours;
          // hours数组
          const hoursList = range(0,24);
          // 结束禁用小时列表
          const endDisabledList =  hoursList.splice(hoursList.indexOf(endHours)+1,24);
          // 开始禁用小时列表
          const startDisabledList =  hoursList.splice(0,hoursList.indexOf(startHours));
          if(isSameEnd&&isSameStart){
            return [...startDisabledList,...endDisabledList]
          }
          if(isSameEnd){
            return endDisabledList
          }if(isSameStart){
            return startDisabledList
          }
          return []
        },
        disabledMinutes(data){
          const {flag,createStartTimeNum,makeupStartTimeNum,createStartTimeUnit,makeupStartTimeUnit} = data;
          // 开始时间
          const startTime = flag ? moment(this.current).subtract(Number(makeupStartTimeNum),TIME_UNIT_MAP[makeupStartTimeUnit]):moment(this.current);
          // 结束时间
          const endTime =  moment().add(+Number(createStartTimeNum),TIME_UNIT_MAP[createStartTimeUnit])
          // 是否跟结束日期相同
          const isSameEnd = moment(this.startStation.expectTime||this.current).isSame(endTime, 'day');
          // 是否跟开始时间相同
          const isSameStart = moment(this.startStation.expectTime||this.current).isSame(startTime, 'day');
          // 开始时间是多少小时
          const startHours= flag ? moment(this.current).subtract(Number(makeupStartTimeNum),TIME_UNIT_MAP[makeupStartTimeUnit]).hour():moment(this.current).hour();
          // 获取当前时间小时
          const currentHours = this.startStation.expectTime? moment(this.startStation.expectTime).hour():startHours;
          // 结束时间是多少小时
          const endHours=  moment().add(+Number(createStartTimeNum),TIME_UNIT_MAP[createStartTimeUnit]).hour()
          if(isSameStart&&currentHours === startHours){
            const endMinute = moment(this.current).minute()
            const minuteList = range(0,60);
            const disabled = minuteList.splice(0,minuteList.indexOf(endMinute))
            return disabled
          }if(isSameEnd&&currentHours === endHours){
            const endMinute = moment(this.current).minute()
            const minuteList = range(0,60);
            const disabled = minuteList.splice(minuteList.indexOf(endMinute),60)
            return disabled
          }
          return []
        },
        handleSelect() {
            let params = {}
            // 如果是入库并且入库类型为退货入库，只请求w地址
            if (this.scene === WAREHOUSETYPE.in && this.type === INTYPECODE.return) {
                if(!this.deliverWarehouseCode) {
                    this.$message.warning('请先选择仓库')
                    return 
                }
                params = {
                    data: true, 
                    ownerTenantId: this.deliverWarehouseCode,
                    customerCode: this.customerCode
                }
            }else {
                // params.bizType = 'TRANSPORT'
            }
            this.$refs.SelectAddressDialog.show({
                ...params,
                ownerTenantId: this.deliverWarehouseCode,
                isWharehose: true
            })
        },
        handleAdressFromSelectorChange({
            contacts, telPhone,stationName,
            provinceName, cityName, countyName, address,
            provinceCode, cityCode, countyCode, sourceStationId
        }) {
            this.update({
                contactPhone: telPhone,
                contactName: contacts,
                provinceName,
                cityName,
                countyName,
                address,
                provinceCode,
                cityCode,
                countyCode,
                stationId: sourceStationId,
                stationName,
            })
        },
        handleAdressChange(address) {
            this.update(address)
        },
        update(infos) {
            const {provinceName, cityName, countyName, address} = infos
            this.$emit('change', {
                ...this.startStation,
                ...infos,
                stationFullAddress: `${provinceName || ''}${cityName || ''}${countyName || ''}${address || ''}`
            })
        },
        removeData(){
            const { contactName, contactPhone, expectTime, crmNumber, mileageKm} = this.startStation
            this.$emit('change', {
                stationId: '',
                provinceName: '',
                cityName: '',
                countyName: '',
                address: '',
                defaultAddress: [],
                orderGoodsType: 0,
                contactName, contactPhone, expectTime, crmNumber, mileageKm,
            })
        },
    },
}
</script>

<style lang="less" scoped>
.address-choose {
    padding-left: 32px;
    margin-bottom: 19px;
    .ant-btn {
        padding: 0;
    }
}
// .order-manage-create-page {
//     border: 0;
// }
.title {
    font-size: 30px;
    font-weight: 500;
}

.subtitle-label{
    display: flex;
    .subtitle {
        flex: 1;
        font-weight: bold;
        font-size: 16px;
    }
}
/deep/ .subtitle-label {
    margin-bottom: 10px;
}
.addressIcon{
    width: 16px;
    margin-top: -2px;
}
/deep/ .ant-card-body{
    padding-top: 16px !important;
}
</style>